module.exports = __webpack_public_path__ + "i.no2.b3f92887.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/i.no2.jpg
// module id = 8A/3
// module chunks = 0